import React, { useState, useRef, useEffect } from 'react';
import { BiDollarCircle, BiShoppingBag, BiUserCircle, BiWallet } from "react-icons/bi";
import { fetchCardsData } from '../../services/client/dashBoardApiService'; 
const iconMapping = {
  0: BiDollarCircle,
  1: BiShoppingBag,
  2: BiUserCircle,
  3: BiWallet,
};

const bgColorMapping = {
  0: "#DAF4F0",
  1: "#DFFAF0",
  2: "#0AB39C",
  3: "#E2E5ED",
};

export function SummaryCards() {
  const [data, setData] = useState([]);
  const emptyData = [
    {
      title: "ALLOCATION PENDING",
      value: "",
      change: "",
      linkText: "",
      bgColor: "#DAF4F0",
      textColor: "#0AB39C",
      iconName: "TOTAL_EARNINGS",
    },
    {
      title: "ORDERS",
      value: "",
      change: "",
      linkText: "",
      bgColor: "#DFFAF0",
      textColor: "#F06548",
      iconName: "ORDERS",
    },
    {
      title: "CUSTOMERS",
      value: "",
      change: "",
      linkText: "",
      bgColor: "#FEF4E4",
      textColor: "#0AB39C",
      iconName: "CUSTOMERS",
    },
    {
      title: "MY BALANCE",
      value: "",
      change: "",
      linkText: "",
      bgColor: "#E2E5ED",
      textColor: "#878A99",
      iconName: "MY_BALANCE",
    },
  ];

    useEffect(() => {
            const fetchCardsData1 = async () => {
                try {
                    const fetchedData = await fetchCardsData(localStorage.getItem('clientID'));
                    if(fetchCardsData==null || fetchCardsData.length==0 ){
                      setData(emptyData);
                    }else{
                      const updatedData = fetchedData.success.map(item => {
                        let bgColor = '';
                        let textColor = '';
                        let iconName = '';
                  
                        // Example logic to set bgColor, textColor, and iconName
                        switch(item.title) {
                          case 'ALLOCATION PENDING':
                            bgColor = '#DAF4F0';
                            textColor = '#0AB39C';
                            iconName = '0';
                            break;
                          case 'PENDING COMPONENTS':
                            bgColor = '#DFFAF0';
                            textColor = '#F06548';
                            iconName = '1';
                            break;
                          case 'APPROVAL PENDING':
                            bgColor = '#FEF4E4';
                            textColor = '#0AB39C';
                            iconName = '2';
                            break;
                          case 'EDIT COMPONENTS':
                            bgColor = '#E2E5ED';
                            textColor = '#878A99';
                            iconName = '3';
                            break;
                          default:
                            bgColor = 'white';
                            textColor = 'black';
                            iconName = '3';
                        }
                        return {
                          ...item,
                          bgColor,
                          textColor,
                          iconName
                        };
                      });
                      setData(updatedData);
                    }
                } catch (error) {
                    console.error("Error fetching service types:", error);
                }
            };
            fetchCardsData1();
        }, []);
    
  return (
    <div className="md:px-[4px] space-y-2">
      <div className="flex flex-wrap -mx-2 justify-center">
        {data.map((card, index) => {
          const IconComponent = iconMapping[card?.iconName];
          return (
            <div key={index} className="w-full sm:w-1/2 xl:w-1/4 p-[12px]">
              <div className="bg-white rounded-md shadow p-4 flex flex-col justify-between h-full transform transition-transform duration-300 hover:shadow-md hover:shadow-gray-500/50 hover:-translate-y-2">
                <div className="flex justify-between">
                  <p className="text-[13px] font-medium leading-[19.5px] uppercase text-[#878A99]">{card?.title}</p>
                  <p className={`text-[14px] font-medium leading-[16.8px] text-[#878A99}]`}></p>
                </div>
                <div className="flex justify-between items-end mt-4">
                  <div>
                    <p className="text-[22px] font-semibold leading-[26.4px] text-[#495057]">{card?.value}</p>
                    <p className="text-[#405189] underline cursor-pointer mt-4 text-[13px] leading-[19.5px]">{card?.linkText}</p>
                  </div>
                  <div className="w-12 h-12 flex items-center justify-center rounded-sm" style={{ backgroundColor: card?.bgColor }}>
                    <IconComponent className="h-6 w-6" />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
